/* AAB Pumps — global theme behaviour */
(function () {
  'use strict';

  /* ---- Sticky / scrolled header state ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 20) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile menu toggle ---- */
  var menuToggles = document.querySelectorAll('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggles.length && mobileMenu) {
    function setMenu(open) {
      mobileMenu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      menuToggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    menuToggles.forEach(function (t) {
      t.addEventListener('click', function () {
        setMenu(!mobileMenu.classList.contains('is-open'));
      });
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenu(false);
    });
  }

  /* ---- Reveal on scroll ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Autoplay videos when in view (browsers block autoplay for off-screen / hidden videos) ---- */
  var autoVids = document.querySelectorAll('video[autoplay]');
  if (autoVids.length) {
    var playVid = function (v) { try { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} };
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) playVid(e.target);
          else { try { e.target.pause(); } catch (err) {} }
        });
      }, { threshold: 0.15 });
      autoVids.forEach(function (v) { vio.observe(v); });
    } else {
      autoVids.forEach(playVid);
    }
  }

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var val = parseInt(input.value, 10) || 1;
    var next = Math.max(parseInt(input.min, 10) || 1, val + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
